import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Loader from '../loader/loader';

import logo from 'assets/images/bamboo.png';
import './withAuthLoader.css';

class WithAuthLoader extends Component {

  render() {
    return (
      <Row className="auth-loader-row">
        <Col className="auth-loader-div">
          <img src={logo} alt="Bamboo logo" className="auth-loader-logo" />
          <Loader
            loading={true}
            loaderStyle="auth-loader-spinner"
          />
        </Col>
      </Row>
    )
  }
}

export default WithAuthLoader;